var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:['sider-trigger-a', _vm.collapsed ? 'collapsed' : ''],attrs:{"type":"text"},on:{"click":_vm.handleChange}},[_c('img',{style:({ width: _vm.size + 'px', height: _vm.size + 'px' }),attrs:{"src":_vm.icon,"alt":_vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }